import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { RolesTitle, RoleDataTitle } from "../../../Constants/Constants";

import RoleTable from "./RoleTable";
const RoleContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={RolesTitle} parent={RoleDataTitle} />
      <Container fluid>
        <Row>
          <RoleTable />
        </Row>
      </Container>
    </>
  );
};

export default RoleContainer;
